<template>
  <div class="online-content">
    <div class="study-center__page">
      <div class="study-center__home" :style="{
				'width': isStudent ? '660px' : '530px'
			}">
        <div class="row">
          <router-link :to="{path: '/Review'}" tag="div" class="item item-study">
            <span>{{ $store.state.globalTxt.studymenu1?$store.state.globalTxt.studymenu1:$t('Header.review') }}</span>
          </router-link>
          <router-link :to="{path: '/studyEvaluate'}" tag="div" class="item item-evaluating">
            <span>{{$store.state.globalTxt.studymenu2?$store.state.globalTxt.studymenu2:$t('Header.evaluation')}}</span>
          </router-link>
        </div>
        <div class="row">
          <!-- 幼儿 mp3 -->
          <!--<router-link :to="{path: '/Mp3'}" tag="div" class="item item-mp3" v-if="kctvIsOpen =='kid' && languageType=='zh'">
            <span>mp3</span>
          </router-link>-->
          <!-- 少儿 视频 -->
          <router-link v-if="kctvIsOpen =='1' && languageType=='zh'" :to="{path: '/Classroom'}" tag="div" class="item item-quket item-quket-new">
            <span>{{$store.state.globalTxt.studymenu5?$store.state.globalTxt.studymenu5:$t('Header.FunClass')}}</span>
          </router-link>
          <router-link v-if="kctvIsOpen =='1' && languageType=='tw'" :to="{path: '/Classroom'}" tag="div" class="item item-quket item-quket1 item-quket-new">
            <span>{{$store.state.globalTxt.studymenu5?$store.state.globalTxt.studymenu5:$t('Header.FunClass')}}</span>
          </router-link>
          <router-link :to="{path: '/Video'}" tag="div" class="item item-video">
            <span>{{$store.state.globalTxt.studymenu3?$store.state.globalTxt.studymenu3:$t('Header.vedio')}}</span>
          </router-link>
          <router-link :to="{path: '/Book'}" tag="div" class="item item-book">
            <span>{{$store.state.globalTxt.studymenu4?$store.state.globalTxt.studymenu4:$t('Header.book')}}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isStudent: true,
      kctvIsOpen :'',
      languageType:"zh"
    };
  },
  created() {
    this.kctvIsOpen = this.$store.state.currentChild.classcode_kctvopen
    this.languageType = this.$Tool.getStorage("languageType");//学前(幼儿)不显示mp3
    console.log(this.$Tool.getStorage("languageType"))
  },
};
</script>
<style lang="stylus">
@import './study-center.styl';
</style>